module.exports = __webpack_public_path__ + "media/images/common/sns/instagram-b76db8e0a7798455ef773adda027842d.png";